import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Field, Checkbox, RadioGroup, Message } from '../../Core';
import { ListDropdown } from '../../List';
import { actions } from '../../../Data/ReduxViewModels/SearchWorksheets';
import { ListFieldSection } from '../../Layout';
import { FilterTestStatus } from '../../../Data/Search';

const FilterSearch = () => {
  const dispatch = useDispatch();
  let filter = useSelector((state) => state.searchWorksheets.filter);
  const [onlyRecentTests, setOnlyRecentTests] = useState(filter.onlyRecentTests);
  const [testStatus, setTestStatus] = useState(filter.testStatus);
  const [testMethods, setTestMethods] = useState(filter.testMethods);

  useEffect(() => {
    dispatch(
      actions.filterSet({
        filter: {
          onlyRecentTests,
          testStatus,
          testMethods,
        },
      })
    );
  }, [dispatch, onlyRecentTests, testStatus, testMethods]);

  return (
    <div className="FilterSearch">
      <ListFieldSection wide>
        <Field
          input={<Checkbox />}
          label="Only Recent Tests"
          value={onlyRecentTests}
          onChange={(e) => setOnlyRecentTests(e.data.value)}
        />
        {!onlyRecentTests && (
          <Message info>
            A full sample ID is required when searching through all tests. Only tests on the sample with the entered
            Sample ID will be shown.
          </Message>
        )}
        <Field
          input={<RadioGroup />}
          label="Test Status"
          options={[
            { label: 'All statuses', value: FilterTestStatus.allStatuses },
            { label: 'Checked or reported', value: FilterTestStatus.checkedOrReported },
            { label: 'Ready for checking', value: FilterTestStatus.readyForChecking },
            { label: 'Incomplete', value: FilterTestStatus.incomplete },
          ]}
          value={testStatus}
          onChange={(e) => setTestStatus(e.data.value)}
        />
        <Field
          input={<ListDropdown />}
          label="Test Methods"
          value={testMethods}
          onChange={(e) => setTestMethods(e.data.value)}
          endpoint="list.worksheetTypes"
          isMulti={true}
        />
      </ListFieldSection>
    </div>
  );
};

export { FilterSearch };
export default FilterSearch;
